<template>
    <VuePerfectScrollbar class="scroll-area">
    
    
    
        <div id="mainMenu">
    
    
    
            <el-menu class="style-fullWidth" background-color="var(--color-dark-cerulean)" text-color="#fff" active-text-color="#ffd04b" :unique-opened="true" :default-active="defaultActiveMenuCode">
    
    
    
                <template v-for="menu1 in menuRoot.children">
    
        
    
                  <!--menu lvl1-->
    
        
    
                  <el-menu-item
    
        
    
                    class="padding-left-0 root-menu"
    
        
    
                    :key="menu1.label"
    
        
    
                    :index="menu1.label"
    
        
    
                    v-if="!!menu1.isLeaf"
    
        
    
                    v-show="isMenuEnable(menu1)"
    
        
    
                    @click="menuClicked(menu1)"
    
        
    
                  >
    
        
    
                    <template #title>
    
        
    
                      <i v-if="!!menu1.iconClass" :class="[menu1.iconClass]"></i>
    
        
    
                      <span>&nbsp; {{ getMenuLabel(menu1) }}</span>
</template>
          </el-menu-item>

          <el-submenu
            v-else
            class="root-menu"
            :key="menu1.label"
            :index="menu1.label"
            v-show="isMenuEnable(menu1)"
            @click="menuClicked(menu1)"
          >
<template #title>
    <div @click="menuClicked(menu1)">
    
    
    
        <i v-if="!!menu1.iconClass" :class="[menu1.iconClass]"></i>
    
    
    
        <span>&nbsp; {{ getMenuLabel(menu1) }}</span>
    
    
    
    </div>
</template>

            <!--menu lvl2-->
<template v-for="menu2 in menu1.children">
    <el-menu-item :key="menu2.label" :index="menu2.label" v-if="!!menu2.isLeaf && !menu2.permission" v-show="isMenuEnable(menu2)" @click="menuClicked(menu2)">
    
    
    
        <i v-if="!!menu2.iconClass" :class="[menu2.iconClass]"></i> {{ getMenuLabel(menu2) }}
    
    
    
    </el-menu-item>
    
    
    
    <el-submenu v-else-if="!menu2.permission" :key="menu2.label" :index="menu2.label" v-show="isMenuEnable(menu2)" @click="menuClicked(menu2)">
    
    
    
        <template #title>
    
        
    
                          <div class="style-fullWidth" @click="menuClicked(menu2)">
    
        
    
                            <i v-if="!!menu2.iconClass" :class="[menu2.iconClass]"></i>
    
        
    
                            <span>{{ getMenuLabel(menu2) }}</span>
    
        
    
                          </div>
</template>
                <!--menu lvl3-->
                <el-menu-item
                  v-for="menu3 in menu2.children"
                  :key="menu3.label"
                  :index="menu3.label"
                  v-show="isMenuEnable(menu3)"
                  @click="menuClicked(menu3)"
                  >{{ getMenuLabel(menu3) }}
                </el-menu-item>
                <!--menu lvl3-->
              </el-submenu>
              <!--            </el-menu-item-group>-->
            </template>
            <!--menu lvl2:end-->
          </el-submenu>
          <!--menu lvl1:end-->
        </template>
      </el-menu>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../constants.js";
import menuConfigService from "../../services/menuConfigService";
import h from "../../services/h";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";

export default {
    name: "list-menu-new",
    components: {
        VuePerfectScrollbar,
    },
    data() {
        return {
            indexSubMenuActive: [],
            docInBookType: constants.BOOK_TYPE.VB_DEN,
            docOutBookType: constants.BOOK_TYPE.VB_DI,
            VIEW_TYPE: constants.JOB_INDEX_PAGE.VIEW_TYPE,
            enableMenuCodes: [],
            userDeptRole: null,
            menuRoot: null,
            defaultActiveMenuCode: null,
        };
    },

    computed: {
        userDeptRoleId() {
            return this.$store.getters.userDeptRoleId;
        },
        currentUserDeptRole() {
            return this.$store.getters.userDeptRole;
        },
        isAdminTCT() {
            return (
                this.currentUserDeptRole &&
                this.currentUserDeptRole.roleCode === constants.ROLE.CODE.ADMIN &&
                this.currentUserDeptRole.deptCode === constants.ROOT_DEPT_CODE
            );
        },
    },

    watch: {
        $route(to, from) {
            this.initDefaultActiveMenuCode();
        },
        userDeptRoleId() {
            this.initDefaultActiveMenuCode();
            this.$nextTick(async () => {
                await this.loadUserDeptRole();
                await this.loadMenuConfigs();
            });
        },
    },

    async created() {
        this.initMenuRoot();
        this.initMenuTreeLevel(this.menuRoot);
        this.initMenuIsLeaf(this.menuRoot);
        this.initDefaultActiveMenuCode();
        await this.loadUserDeptRole();
        await this.loadMenuConfigs();
    },

    methods: {
        initDefaultActiveMenuCode() {
            this.defaultActiveMenuCode = this.findActiveMenuCodeByRouteName();
        },

        findActiveMenuCodeByRouteName() {
            switch (this.$route.name) {
                //van ban den
                case "vbChoTiepNhan":
                case "vbChoTiepNhanDetail":
                case "vbChoTiepNhanDetailEditable":
                    return constants.MENU_LIST.VB_DEN_CHOTIEPNHAN;
                case "vbDenChoXuLy":
                case "vbDenChoXuLyDetail":
                    return constants.MENU_LIST.VB_DEN_CHOXULY;
                case "vbDenDaXuLy":
                case "vbDenDaXuLyDetail":
                    return constants.MENU_LIST.VB_DEN_DAXULY;
                case "vbDenUyQuyen":
                case "vbDenUyQuyenDetail":
                    return constants.MENU_LIST.VB_DEN_UYQUYEN;
                case "vbDenDaXuLyVT":
                case "vbDenDaXuLyVTDetail":
                    return constants.MENU_LIST.VB_DEN_DAXULY_VT;
                case "vbDenDaTiepNhan":
                case "vbDenDaTiepNhanDetail":
                    return constants.MENU_LIST.VB_DEN_DATIEPNHAN;
                case "toTrinhQuaHan":
                case "toTrinhQuaHanDetail":
                    return constants.MENU_LIST.VB_DEN_TO_TRINH_QUA_HAN;
                    //van ban den:end

                    //van ban di
                case "vbDaBanHanh":
                case "vbDaBanHanhDetail":
                    return constants.MENU_LIST.VB_DI_DABANHANH;
                case "vbDuThaoNew":
                case "vbDuThaoNewDetail":
                case "vbDuThaoNewEdit":
                    return constants.MENU_LIST.VB_DI_DUTHAO;
                case "vbDaPhatHanhNew":
                case "vbDaPhatHanhNewDetail":
                    return constants.MENU_LIST.VB_DI_DAPHATHANH;
                case "vbChoBanHanh":
                case "vbChoBanHanhDetail":
                case "vbChoBanHanhHieuChinh":
                    return constants.MENU_LIST.VB_DI_CHOBANHANH;
                    //van ban di:end;

                    //ql sổ văn bản
                case "quanlySoDi":
                case "vbDiDaVaoSo":
                case "quanlySoDiDetail":
                    return constants.MENU_LIST.QL_SOVANBAN_SODI;
                case "quanlySoDen":
                case "vbDaVaoSo":
                case "quanlySoDenDetail":
                    return constants.MENU_LIST.QL_SOVANBAN_SODEN;
                case "bookSo":
                    return constants.MENU_LIST.QL_SOVANBAN_BOOKSO;
                    //ql sổ văn bản:end;

                    //công việc;
                case "job-index-assigned":
                case "detail-job-assigned":
                    return constants.MENU_LIST.CONGVIEC_GIAO;
                case "job-index-coordinate":
                case "detail-job-coordinate":
                    return constants.MENU_LIST.CONGVIEC_LIENQUAN;
                case "job-index-dept-assigned":
                case "detail-job-dept-assigned":
                    return constants.MENU_LIST.CONGVIEC_DONVI;
                case "job-index":
                case "detail-job":
                    return constants.MENU_LIST.CONGVIEC_DUOCGIAO;
                case "rankingScoreIndex":
                    return constants.MENU_LIST.CONGVIEC_SCORE;
                    //công việc:end;

                    //Cấu hình
                case "CauHinhLuong":
                case "CauHinhLuongCreate":
                case "CauHinhLuongEdit":
                    return constants.MENU_LIST.CAUHINH_LUONGVANBAN;
                case "QuanLyVaiTro":
                case "QuanLyVaiTroDetail":
                    return constants.MENU_LIST.CAUHINH_QUANLYVAITRO;
                case "quanTriNguoiDung":
                case "QuanTriNguoiDungDetail":
                    return constants.MENU_LIST.CAUHINH_QUANTRINGUOIDUNG;
                case "QuanTriDonVi":
                case "QuanTriDonViDetail":
                    return constants.MENU_LIST.CAUHINH_QUANTRIDONVI;
                case "QuanLyUyQuyen":
                case "QuanLyUyQuyenDetail":
                    return constants.MENU_LIST.CAUHINH_QUANLYUYQUYEN;
                case "QuanLyDanhMuc":
                case "QuanLyDanhMucDetail":
                    return constants.MENU_LIST.CAUHINH_QUANLYDANHMUC;
                case "QuanLyPhongHop":
                case "QuanLyPhongHopDetail":
                    return constants.MENU_LIST.CAUHINH_QUANLYPHONGHOP;
                case "rankingReasonIndex":
                    return constants.MENU_LIST.CAUHINH_RANKINGREASON;
                case "ThuVienDungChung":
                    return constants.MENU_LIST.THUVIEN;
                case "QuanLyTaiXe":
                    return constants.MENU_LIST.CAUHINH_QUANLYTAIXE;
                case "danhMucXe":
                    return constants.MENU_LIST.CAUHINH_QUANLYXE;
                case "QuanLyLoaiTaiLieu":
                    return constants.MENU_LIST.CAUHINH_DOCUMENTTYPE;
                case "QuanLyNhomThaoLuan":
                    return constants.MENU_LIST.CAUHINH_THAOLUAN;
                    //Cấu hình:end;

                    //hành chính:
                case "adminstration-index":
                case "adminstration-detail":
                case "adminstration-regisRoomCalendar":
                    return constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOP;
                case "adminstration-getCar":
                case "adminstration-getCarDetail":
                case "adminstration-getCarCalendar":
                    return constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXE;
                case "adminstration-regiscalendarweek":
                case "adminstration-regiscalendarweekCalendar":
                case "adminstration-regiscalendarweek-detail":
                    return constants.MENU_LIST.HANHCHINH_DANGKYLICHTUAN;
                    //hành chính:end;

                    //báo cáo
                case "reportIndex":
                    return constants.MENU_LIST.BAOCAO;
                    //báo cáo:end;

                    // Danh bạ
                case "contact":
                    return constants.MENU_LIST.DANHBA;

                    // Quản lý tài liệu
                case "DocumentDetail":
                case "document":
                    return constants.MENU_LIST.KHOTAILIEU;

                    // Quản lý thông báo
                case "notifi":
                case "notifiDetail":
                    return constants.MENU_LIST.QL_THONG_BAO;

                case "myNotifi":
                case "myNotifiDetail":
                    return constants.MENU_LIST.XEM_THONG_BAO;

                    // Quản lý nhân sự
                case "office-doc":
                    return constants.MENU_LIST.OFFICE_DOC;

                case "office-user":
                case "office-user-detail":
                    return constants.MENU_LIST.OFFICE_USER;

                case "office-config":
                    return constants.MENU_LIST.OFFICE_CONFIG;

                    // Tin tức hàng ngày
                case "news":
                case "newsDetail":
                    return constants.MENU_LIST.TIN_TUC;

                    // Quản lý thảo luận
                case "discussion":
                case "discussionDetail":
                    return constants.MENU_LIST.THAO_LUAN;

                default:
                    return constants.MENU_LIST.DASHBBOARD;
            }
        },

        menuClicked(menu) {
            this.routeByMenu(menu);
        },

        routeByMenu(menu) {
            return this.$router.push({
                name: this.findRouteNameByMenu(menu),
                params: this.buildRouteParamsByMenu(menu),
                query: this.buildRouteQueryByMenu(menu),
            });
        },

        findRouteNameByMenu(menu) {
            switch (menu.label) {
                case constants.MENU_LIST.DASHBBOARD:
                    return "dashboard";
                case constants.MENU_LIST.DASHBBOARD_2:
                    return "dashboard2";
                case constants.MENU_LIST.TIN_TUC:
                    return "news";
                case constants.MENU_LIST.DANHBA:
                    return "contact";
                case constants.MENU_LIST.KHOTAILIEU:
                    return "document";
                case constants.MENU_LIST.XEM_THONG_BAO:
                    return "myNotifi";
                case constants.MENU_LIST.QL_THONG_BAO:
                    return "notifi";
                case constants.MENU_LIST.OFFICE_DOC:
                    return "office-doc";
                case constants.MENU_LIST.OFFICE_CONFIG:
                    return "office-config";
                case constants.MENU_LIST.OFFICE_USER:
                    return "office-user";
                case constants.MENU_LIST.VB_DEN_CHOTIEPNHAN:
                    return "vbChoTiepNhan";
                case constants.MENU_LIST.VB_DEN_DATIEPNHAN:
                    return "vbDenDaTiepNhan";
                    // case constants.MENU_LIST.VB_DEN:
                case constants.MENU_LIST.VB_DEN_CHOXULY:
                case constants.MENU_LIST.VB_DEN_CHOXULY_PHOIHOP:
                case constants.MENU_LIST.VB_DEN_CHOXULY_CHUTRI:
                case constants.MENU_LIST.VB_DEN_CHOXULY_NHANDEBIET:
                    return "vbDenChoXuLy";
                case constants.MENU_LIST.VB_DEN_DAXULY:
                case constants.MENU_LIST.VB_DEN_DAXULY_PHOIHOP:
                case constants.MENU_LIST.VB_DEN_DAXULY_CHUTRI:
                case constants.MENU_LIST.VB_DEN_DAXULY_NHANDEBIET:
                    return "vbDenDaXuLy";
                case constants.MENU_LIST.VB_DEN_UYQUYEN:
                    return "vbDenUyQuyen";
                case constants.MENU_LIST.VB_DEN_TO_TRINH_QUA_HAN:
                    return "toTrinhQuaHan";
                case constants.MENU_LIST.VB_DEN_DAXULY_VT:
                    return "vbDenDaXuLyVT";
                    // case constants.MENU_LIST.VB_DI:
                case constants.MENU_LIST.VB_DI_DUTHAO:
                    return "vbDuThaoNew";
                case constants.MENU_LIST.VB_DI_DAPHATHANH:
                    return "vbDaPhatHanhNew";
                case constants.MENU_LIST.VB_DI_CHOBANHANH:
                    return "vbChoBanHanh";
                case constants.MENU_LIST.VB_DI_DABANHANH:
                    return "vbDaBanHanh";
                case constants.MENU_LIST.QL_SOVANBAN_SODEN:
                    return "quanlySoDen";
                case constants.MENU_LIST.QL_SOVANBAN_SODI:
                    return "quanlySoDi";
                case constants.MENU_LIST.QL_SOVANBAN_BOOKSO:
                    return "bookSo";
                case constants.MENU_LIST.CONGVIEC_DUOCGIAO:
                    return "job-index";
                case constants.MENU_LIST.CONGVIEC_GIAO:
                    return "job-index-assigned";
                case constants.MENU_LIST.CONGVIEC_DONVI:
                    return "job-index-dept-assigned";
                case constants.MENU_LIST.CONGVIEC_LIENQUAN:
                    return "job-index-coordinate";
                case constants.MENU_LIST.CONGVIEC_SCORE:
                    return "rankingScoreIndex";
                case constants.MENU_LIST.CAUHINH_LUONGVANBAN:
                    return "CauHinhLuong";
                case constants.MENU_LIST.CAUHINH_QUANTRIDONVI:
                    return "QuanTriDonVi";
                case constants.MENU_LIST.CAUHINH_QUANTRINGUOIDUNG:
                    return "quanTriNguoiDung";
                case constants.MENU_LIST.CAUHINH_QUANLYVAITRO:
                    return "QuanLyVaiTro";
                case constants.MENU_LIST.CAUHINH_QUANLYPHONGHOP:
                    return "QuanLyPhongHop";
                case constants.MENU_LIST.CAUHINH_QUANLYTAIXE:
                    return "QuanLyTaiXe";
                case constants.MENU_LIST.CAUHINH_QUANLYXE:
                    return "danhMucXe";
                case constants.MENU_LIST.CAUHINH_RANKINGREASON:
                    return "rankingReasonIndex";
                case constants.MENU_LIST.CAUHINH_DOCUMENTTYPE:
                    return "QuanLyLoaiTaiLieu";
                    // case constants.MENU_LIST.CAUHINH_DOCUMENTTYPE_V2:
                    //   return "QuanLyLoaiTaiLieuV2";
                case constants.MENU_LIST.CAUHINH_THAOLUAN:
                    return "QuanLyNhomThaoLuan"
                    //hành chính:
                case constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOP:
                    return "adminstration-index";
                case constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXE:
                    return "adminstration-getCar";
                case constants.MENU_LIST.HANHCHINH_DANGKYLICHTUAN:
                    return "adminstration-regiscalendarweek";
                case constants.MENU_LIST.CAUHINH_QUANLYDANHMUC:
                    return "QuanLyDanhMuc";
                case constants.MENU_LIST.CAUHINH_QUANLYUYQUYEN:
                    return "QuanLyUyQuyen";
                    //hành chính:end;
                    //báo cáo;
                case constants.MENU_LIST.BAOCAO:
                    return "reportIndex";
                    //báo cáo:end;
                case constants.MENU_LIST.THAO_LUAN:
                    return "discussion";
                default:
                    return "dashboard";
            }
        },

        buildRouteParamsByMenu(menu) {
            switch (menu.label) {
                case constants.MENU_LIST.QL_SOVANBAN_SODEN:
                    return {
                        userDeptRoleId: this.userDeptRoleId,
                        bookType: constants.BOOK_TYPE.VB_DEN,
                    };
                case constants.MENU_LIST.QL_SOVANBAN_SODI:
                    return {
                        userDeptRoleId: this.userDeptRoleId,
                        bookType: constants.BOOK_TYPE.VB_DI,
                    };
                default:
                    return { userDeptRoleId: this.userDeptRoleId };
            }
        },

        buildRouteQueryByMenu(menu) {
            switch (menu.label) {
                case constants.MENU_LIST.VB_DEN_CHOXULY:
                case constants.MENU_LIST.VB_DEN_DAXULY:
                    return { filterStatus: constants.VBDEN_CHOXULY_PAGE.FILTER.ALL };
                case constants.MENU_LIST.VB_DEN_CHOXULY_PHOIHOP:
                case constants.MENU_LIST.VB_DEN_DAXULY_PHOIHOP:
                    return { filterStatus: constants.VBDEN_CHOXULY_PAGE.FILTER.PHOI_HOP };
                case constants.MENU_LIST.VB_DEN_CHOXULY_CHUTRI:
                case constants.MENU_LIST.VB_DEN_DAXULY_CHUTRI:
                    return { filterStatus: constants.VBDEN_CHOXULY_PAGE.FILTER.CHU_TRI };
                case constants.MENU_LIST.VB_DEN_CHOXULY_NHANDEBIET:
                case constants.MENU_LIST.VB_DEN_DAXULY_NHANDEBIET:
                    return {
                        filterStatus: constants.VBDEN_CHOXULY_PAGE.FILTER.NHAN_DE_BIET,
                    };
                case constants.MENU_LIST.CONGVIEC_DUOCGIAO:
                    return { viewType: constants.JOB_INDEX_PAGE.VIEW_TYPE.RECEIVER };
                case constants.MENU_LIST.CONGVIEC_GIAO:
                    return { viewType: constants.JOB_INDEX_PAGE.VIEW_TYPE.ASSIGNER };
                case constants.MENU_LIST.CONGVIEC_DONVI:
                    return { viewType: constants.JOB_INDEX_PAGE.VIEW_TYPE.DEPT_ASSIGNER };
                case constants.MENU_LIST.CONGVIEC_LIENQUAN:
                    return { viewType: constants.JOB_INDEX_PAGE.VIEW_TYPE.COORDINATOR };
                default:
                    return null;
            }
        },

        getMenuLabel(menu) {
            switch (menu.label) {
                case constants.MENU_LIST.VB_DEN_CHOXULY_CHUTRI:
                case constants.MENU_LIST.VB_DEN_DAXULY_CHUTRI:
                    return "Chủ trì";

                case constants.MENU_LIST.VB_DEN_CHOXULY_PHOIHOP:
                case constants.MENU_LIST.VB_DEN_DAXULY_PHOIHOP:
                    return "Phối hợp";

                case constants.MENU_LIST.VB_DEN_CHOXULY_NHANDEBIET:
                case constants.MENU_LIST.VB_DEN_DAXULY_NHANDEBIET:
                    return "Nhận để biết";

                default:
                    return menu.label;
            }
        },

        initMenuRoot() {
            this.menuRoot = {
                id: -1,
                children: [{
                        id: 0,
                        label: constants.MENU_LIST.DASHBBOARD,
                        iconClass: "fas fa-home fa-fw",
                    },
                    // {
                    //   id: 11,
                    //   label: constants.MENU_LIST.DASHBBOARD_2,
                    //   iconClass: "fas fa-home fa-fw",
                    // },
                    {
                        id: 13,
                        label: constants.MENU_LIST.TIN_TUC,
                        iconClass: "fas fa-newspaper fa-fw",
                    },
                    {
                        id: 1,
                        label: constants.MENU_LIST.VB_DEN,
                        iconClass: "far fa-inbox-in fa-fw",
                        children: [
                            { id: 11, label: constants.MENU_LIST.VB_DEN_CHOTIEPNHAN },
                            {
                                id: 12,
                                label: constants.MENU_LIST.VB_DEN_CHOXULY,
                                // children: [
                                //   { id: 121, label: constants.MENU_LIST.VB_DEN_CHOXULY_CHUTRI },
                                //   {
                                //     id: 122,
                                //     label: constants.MENU_LIST.VB_DEN_CHOXULY_PHOIHOP,
                                //   },
                                //   {
                                //     id: 123,
                                //     label: constants.MENU_LIST.VB_DEN_CHOXULY_NHANDEBIET,
                                //   },
                                // ],
                            },
                            {
                                id: 13,
                                label: constants.MENU_LIST.VB_DEN_DAXULY,
                                // children: [
                                //   { id: 131, label: constants.MENU_LIST.VB_DEN_DAXULY_CHUTRI },
                                //   { id: 132, label: constants.MENU_LIST.VB_DEN_DAXULY_PHOIHOP },
                                //   {
                                //     id: 133,
                                //     label: constants.MENU_LIST.VB_DEN_DAXULY_NHANDEBIET,
                                //   },
                                // ],
                            },
                            { id: 14, label: constants.MENU_LIST.VB_DEN_UYQUYEN },
                            { id: 15, label: constants.MENU_LIST.VB_DEN_DATIEPNHAN },
                            { id: 16, label: constants.MENU_LIST.VB_DEN_DAXULY_VT },
                            { id: 17, label: constants.MENU_LIST.VB_DEN_TO_TRINH_QUA_HAN },
                        ],
                    },
                    {
                        id: 2,
                        label: constants.MENU_LIST.VB_DI,
                        iconClass: "far fa-inbox-out fa-fw",
                        children: [
                            { id: 21, label: constants.MENU_LIST.VB_DI_DUTHAO },
                            { id: 22, label: constants.MENU_LIST.VB_DI_DAPHATHANH },
                            { id: 23, label: constants.MENU_LIST.VB_DI_CHOBANHANH },
                            { id: 24, label: constants.MENU_LIST.VB_DI_DABANHANH },
                            { id: 25, label: constants.MENU_LIST.VB_DI_LUONGVB },
                        ],
                    },
                    {
                        id: 3,
                        label: constants.MENU_LIST.QL_SOVANBAN,
                        iconClass: "far fa-book fa-fw",
                        children: [
                            { id: 31, label: constants.MENU_LIST.QL_SOVANBAN_SODEN },
                            { id: 32, label: constants.MENU_LIST.QL_SOVANBAN_SODI },
                            { id: 33, label: constants.MENU_LIST.QL_SOVANBAN_BOOKSO },
                        ],
                    },
                    {
                        id: 4,
                        label: constants.MENU_LIST.CONGVIEC,
                        iconClass: "far fa-tasks fa-fw",
                        children: [
                            { id: 41, label: constants.MENU_LIST.CONGVIEC_GIAO },
                            { id: 42, label: constants.MENU_LIST.CONGVIEC_DUOCGIAO },
                            { id: 43, label: constants.MENU_LIST.CONGVIEC_LIENQUAN },
                            {
                                id: 44,
                                label: constants.MENU_LIST.CONGVIEC_DONVI,
                                permission: this.$store.getters.userDeptRole &&
                                    (this.$store.getters.userDeptRole.roleCode ===
                                        constants.ROLE.CODE.CHUYEN_VIEN ||
                                        this.$store.getters.userDeptRole.roleCode ===
                                        constants.ROLE.CODE.VAN_THU),
                            },
                            // {id: 45, label: constants.MENU_LIST.CONGVIEC_SCORE}
                        ],
                    },
                    {
                        id: 8,
                        label: constants.MENU_LIST.KHOTAILIEU,
                        iconClass: "far fa-file-alt fa-fw",
                    },
                    {
                        id: 6,
                        label: constants.MENU_LIST.HANHCHINH,
                        iconClass: "far fa-clipboard-list-check fa-fw",
                        children: [
                            { id: 61, label: constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOP },
                            // {
                            //   id: 62,
                            //   label: constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOPDOTXUAT
                            // },
                            { id: 63, label: constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXE },
                            // {
                            //   id: 64,
                            //   label: constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXEDOTXUAT
                            // },
                            // {
                            //   id: 65,
                            //   label: constants.MENU_LIST.HANHCHINH_THEODOIKETLUANCHIDAO
                            // },
                            { id: 66, label: constants.MENU_LIST.HANHCHINH_DANGKYLICHTUAN },
                            // {id: 67, label: constants.MENU_LIST.HANHCHINH_VEMAYBAY},
                            // {id: 68, label: constants.MENU_LIST.HANHCHINH_KHACHSAN},
                            // {id: 69, label: constants.MENU_LIST.SUA_CHUA_NHO}
                        ],
                    },
                    {
                        id: 5,
                        label: constants.MENU_LIST.CAUHINH,
                        iconClass: "far fa-cog fa-fw",
                        children: [
                            { id: 501, label: constants.MENU_LIST.CAUHINH_LUONGVANBAN },
                            // { id: 502, label: constants.MENU_LIST.CAUHINH_QUANTRINGUOIDUNG },
                            { id: 503, label: constants.MENU_LIST.CAUHINH_QUANTRIDONVI },
                            { id: 504, label: constants.MENU_LIST.CAUHINH_QUANLYUYQUYEN },
                            { id: 506, label: constants.MENU_LIST.CAUHINH_QUANLYDANHMUC },
                            { id: 507, label: constants.MENU_LIST.CAUHINH_QUANLYVAITRO },
                            { id: 508, label: constants.MENU_LIST.CAUHINH_QUANLYPHONGHOP },
                            { id: 509, label: constants.MENU_LIST.CAUHINH_QUANLYTAIXE },
                            { id: 510, label: constants.MENU_LIST.CAUHINH_QUANLYXE },
                            { id: 511, label: constants.MENU_LIST.CAUHINH_RANKINGREASON },
                            { id: 512, label: constants.MENU_LIST.CAUHINH_DOCUMENTTYPE },
                            // { id: 5121, label: constants.MENU_LIST.CAUHINH_DOCUMENTTYPE_V2 },
                            { id: 515, label: constants.MENU_LIST.CAUHINH_THAOLUAN }
                        ],
                    },
                    {
                        id: 10,
                        label: constants.MENU_LIST.THONG_BAO,
                        iconClass: "far fa-bell fa-fw",
                        children: [
                            { id: 101, label: constants.MENU_LIST.XEM_THONG_BAO },
                            {
                                id: 102,
                                label: constants.MENU_LIST.QL_THONG_BAO,
                            },
                        ],
                    },
                    {
                        id: 12,
                        label: constants.MENU_LIST.OFFICE,
                        iconClass: "far fa-user fa-fw",
                        children: [
                            { id: 121, label: constants.MENU_LIST.OFFICE_DOC },
                            {
                                id: 122,
                                label: constants.MENU_LIST.OFFICE_USER,
                            },
                            {
                                id: 123,
                                label: constants.MENU_LIST.OFFICE_CONFIG,
                            },
                        ],
                    },
                    {
                        id: 9,
                        label: constants.MENU_LIST.DANHBA,
                        iconClass: "far fa-address-book fa-fw",
                    },
                    {
                        id: 7,
                        label: constants.MENU_LIST.BAOCAO,
                        iconClass: "far fa-analytics fa-fw",
                    },
                    {
                      id: 14,
                      label: constants.MENU_LIST.THAO_LUAN,
                      iconClass: "far fa-comments fa-fw",
                    },
                ],
            };
        },

        initMenuTreeLevel(menuNode, level) {
            menuNode.level = level;
            h.each(menuNode.children, (child) =>
                this.initMenuTreeLevel(child, level + 1)
            );
        },

        initMenuIsLeaf(menuNode) {
            menuNode.isLeaf = !menuNode.children || !menuNode.children.length;
            h.each(menuNode.children, (child) => this.initMenuIsLeaf(child));
        },

        isMenuCodeEnable(menuCode) {
            return (this.enableMenuCodes || []).indexOf(menuCode) !== -1;
        },

        isMenuEnable(menuNode) {
            if (this.menuRoot === menuNode) {
                return true;
            } else {
                switch (menuNode.label) {
                    case constants.MENU_LIST.DASHBBOARD:
                    case constants.MENU_LIST.DASHBBOARD_2:
                        return true;
                    case constants.MENU_LIST.TIN_TUC:
                        return true;
                    case constants.MENU_LIST.CAUHINH_DOCUMENTTYPE:
                        // case constants.MENU_LIST.CAUHINH_DOCUMENTTYPE_V2:
                        return this.isMenuCodeEnable(
                            constants.MENU_LIST.CAUHINH_DOCUMENTTYPE
                        );
                    case constants.MENU_LIST.CAUHINH_THAOLUAN:
                        return this.isMenuCodeEnable(constants.MENU_LIST.CAUHINH_THAOLUAN);
                    case constants.MENU_LIST.KHOTAILIEU:
                        return this.isMenuCodeEnable(constants.MENU_LIST.KHOTAILIEU);
                    case constants.MENU_LIST.DANHBA:
                        return this.isMenuCodeEnable(constants.MENU_LIST.DANHBA);
                    case constants.MENU_LIST.OFFICE:
                        return (
                            // this.isAdminTCT ||
                            this.isMenuCodeEnable(constants.MENU_LIST.OFFICE) ||
                            this.isMenuCodeEnable(constants.MENU_LIST.OFFICE_DOC) ||
                            this.isMenuCodeEnable(constants.MENU_LIST.OFFICE_DOC_REPORT) ||
                            this.isMenuCodeEnable(constants.MENU_LIST.OFFICE_USER) ||
                            this.isMenuCodeEnable(constants.MENU_LIST.OFFICE_CONFIG)
                        );
                    case constants.MENU_LIST.OFFICE_CONFIG:
                        return this.isMenuCodeEnable(constants.MENU_LIST.OFFICE_CONFIG);
                    case constants.MENU_LIST.OFFICE_DOC:
                        return (
                            // this.isAdminTCT ||
                            this.isMenuCodeEnable(constants.MENU_LIST.OFFICE_DOC) ||
                            this.isMenuCodeEnable(constants.MENU_LIST.OFFICE_DOC_REPORT)
                        );
                    case constants.MENU_LIST.OFFICE_USER:
                        return (
                            // this.isAdminTCT ||
                            this.isMenuCodeEnable(constants.MENU_LIST.OFFICE_USER)
                        );
                    case constants.MENU_LIST.THONG_BAO:
                        return (
                            this.isMenuCodeEnable(constants.MENU_LIST.XEM_THONG_BAO) ||
                            this.isMenuCodeEnable(constants.MENU_LIST.THONG_BAO_NOI_BO) ||
                            this.isMenuCodeEnable(constants.MENU_LIST.THONG_BAO_HE_THONG)
                        );
                    case constants.MENU_LIST.XEM_THONG_BAO:
                        return this.isMenuCodeEnable(constants.MENU_LIST.XEM_THONG_BAO);
                    case constants.MENU_LIST.QL_THONG_BAO:
                        return (
                            this.isMenuCodeEnable(constants.MENU_LIST.THONG_BAO_NOI_BO) ||
                            this.isMenuCodeEnable(constants.MENU_LIST.THONG_BAO_HE_THONG)
                        );
                    case constants.MENU_LIST.VB_DEN_CHOXULY_CHUTRI:
                    case constants.MENU_LIST.VB_DEN_CHOXULY_PHOIHOP:
                    case constants.MENU_LIST.VB_DEN_CHOXULY_NHANDEBIET:
                        return this.isMenuCodeEnable(constants.MENU_LIST.VB_DEN_CHOXULY);
                    case constants.MENU_LIST.VB_DEN_DAXULY_CHUTRI:
                    case constants.MENU_LIST.VB_DEN_DAXULY_PHOIHOP:
                    case constants.MENU_LIST.VB_DEN_DAXULY_NHANDEBIET:
                        return this.isMenuCodeEnable(constants.MENU_LIST.VB_DEN_DAXULY);
                    default:
                        return this.isMenuCodeEnable(menuNode.label);
                }
            }
        },

        loadUserDeptRole() {
            return (
                this.userDeptRoleId &&
                userDeptRoleViewService
                .findById(this.userDeptRoleId)
                .then((response) => {
                    this.userDeptRole = response.data;
                })
            );
        },

        findMenuByCode(menuCode) {
            return h.find(this.menus, (menu) => menu.menuCode === menuCode);
        },

        loadMenuConfigs() {
            return menuConfigService
                .findAll({ status: "active" }, { page: 0, size: 1000 })
                .then((response) => {
                    this.enableMenuCodes = h.collect(
                        response.data,
                        (menuConfig) => menuConfig.menuCode
                    );
                    this.$store.commit("setEnableMenuCodes", this.enableMenuCodes);
                });
        },
    },
};
</script>

<style scoped>
.el-menu {
    border-right: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/menu-left/list-menu-new.vue